import { render, staticRenderFns } from "./ProtecaoDeDados.vue?vue&type=template&id=7806dd0a&scoped=true"
import script from "./ProtecaoDeDados.vue?vue&type=script&lang=js"
export * from "./ProtecaoDeDados.vue?vue&type=script&lang=js"
import style0 from "./ProtecaoDeDados.vue?vue&type=style&index=0&id=7806dd0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7806dd0a",
  null
  
)

export default component.exports